import { Heading, Stack } from '@chakra-ui/react';
import * as React from 'react';

import { ITagSearch } from '@/client/legacy-shared-modules/search/search-types';
import { CustomHighlight } from '@/components/CustomHighlight';

import { ListItemHit } from './ListItemHit';

export const TagHit = (
  hit: ITagSearch,
  disableHighlight = false
): React.ReactNode => (
  <ListItemHit key={hit.objectID} to={`/community/tags/${hit.objectID}`}>
    <Stack spacing="1">
      <Heading size="sm">
        {disableHighlight ? (
          hit.name
        ) : (
          <CustomHighlight attribute="name" hit={hit} />
        )}
      </Heading>
    </Stack>
  </ListItemHit>
);
